<template>
	<div class="box box_mm">
		<div class="box_main">
			<div class="search_box">
				<div class="search_item">
					<span style="width: 0.6rem;">名称：</span>
					<el-input v-model="searchinput" placeholder="请输入名称" style="width: 2rem;"></el-input>
				</div>
				<div class="search_item">
					<el-button type="primary" @click="search">搜索</el-button>
					<el-button type="success" @click="addnewyz">新增</el-button>
				</div>
			</div>
			<div class="box_cont">
				<div class="btn_list">
				</div>
				<div style="height: 76vh;box-sizing: border-box;">
					<MyTable ref="zjlist" :tableData="tableData" :tableHeader="tableHeader" :showbm="true"
						:czwidth="150" @getdata="gettable" @changswitch="changswitch">
						<template slot="btns" slot-scope="{ scope }">
							<el-button @click="showeidt(scope.row)" type="warning" size="mini">
								编辑
							</el-button>	
							<el-button @click="deleterow(scope.row)" type="danger" size="mini">
								删除
							</el-button>	
						</template>
					</MyTable>
				</div>
			</div>
		</div>			
		
		
	</div>
</template>

<script>	
	export default{		
		data() {
			return{
				searchinput:'',
				tableHeader: [{
						prop: 'id',
						name: '序',
						width: '50'
					},					
					{
						prop: 'name',
						name: '名称',
						width: ''
					},
					{
						prop: 'area.name',
						name: '所属地区',
						width: '150'
					},
					{
						prop: 'address',
						name: '地址',
						width: ''
					},
					{
						prop: 'fzren',
						name: '负责人',
						width: '150'
					},
					{
						prop: 'lxphone',
						name: '联系电话',
						width: '130'
					}
				],
				tableData: [],
			}
		},
		mounted() {
			this.gettable()
		},
		activated() {
		    this.gettable(); // 每次进入页面时刷新数据
		},
		methods:{
			addnewyz(){
				this.$router.push('/system/yun_yizhan_listadd')
			},			
			showeidt(row){
				this.$router.push({path:"/system/yun_yizhan_listedit",query:{id:row.id}})
			},
			changswitch(row){
				this.$post({
					url: '/api/room/edit',
					params: row
				}).then((res) => {
					this.$message({
						type: 'success',
						message: '操作成功!'
					})
					this.gettable()
				})
			},
			search(){
				this.$refs.zjlist.inputpage = 1
				this.gettable()
			},
			reset() {
				this.searchinput = ''
				this.$refs.zjlist.inputpage = 1
				this.gettable()
			},
			deleterow(row){
				this.$confirm('确认删除该条数据吗？')
					.then(_ => {
						this.$post({
							url: '/api/stage/del',
							params: {
								ids: row.id
							}
						}).then((res) => {
							this.$message.success('删除成功')
							this.gettable()
						})
					})
					.catch(_ => {});
			},
			gettable(){
				this.$post({
					url: '/api/stage/index',
					params: {
						name: this.searchinput,
						p: this.$refs.zjlist.inputpage,
						size: this.$refs.zjlist.pagesize
					}
				}).then((res) => {
					this.tableData = res.list
					this.$refs.zjlist.total = res.count
				})
			},
			addnew(){
				this.$router.push('/system/meeting_add')
			},
			showdate(row){
				this.$refs.myroomdate.dialogVisible = true
			},
		}
	}
</script>

<style lang="scss" scoped>
	@import 'yizhan_list.scss';
</style>